<script>
export default {
  name: 'Datatable',

  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<template>
  <table :class="$classes['datatable']">
    <thead v-if="$slots.thead">
      <slot name="thead" />
    </thead>
    <tbody>
      <slot v-for="(item, index) in items" name="tbody" :item="item" :index="index" />
    </tbody>
    <tfoot v-if="$slots.tfoot">
      <slot name="tfoot" />
    </tfoot>
  </table>
</template>

<style module>
.datatable {
  width: 100%;
  border-spacing: 0;
  border-collapse: separate;
  margin-bottom: 10px;
  background: #ffffff;
  border-radius: 20px;
  overflow: hidden;
  /* box-shadow: 0 8px 0px rgba(0, 0, 0, 0.08); */
  margin-bottom: 32px;
  transition: all 0.3s ease;
}

.datatable:hover {
  /* box-shadow: 0 12px 40px rgba(0, 0, 0, 0.12); */
  border-color: rgba(74, 148, 212, 0.2);
}

.datatable thead {
  /* background: #fff; */
  position: relative;
}

.datatable thead::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0.1) 100%);
}

.datatable thead th {
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  color: #ffffff;
  font-weight: 700;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 0.08em;
  padding: 24px 28px;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  position: relative;
}

.datatable tbody {
  background: #ffffff;
}

.datatable tbody tr {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.datatable tbody tr:hover {
  background: linear-gradient(135deg, rgba(74, 148, 212, 0.03) 0%, rgba(74, 148, 212, 0.01) 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.datatable tbody tr:last-child {
  border-bottom: none;
}

.datatable tbody td {
  color: #212529;
  font-size: 14px;
  padding: 24px 16px;
  font-weight: 500;
  transition: all 0.2s ease;
}

.datatable tfoot {
  border-top: 3px solid rgba(74, 148, 212, 0.1);
}

.datatable tfoot td {
  padding: 24px 28px;
  font-size: 14px;
  font-weight: 700;
  color: #495057;
}

.datatable tfoot tr:nth-child(1) td {
  padding-top: 28px;
}

/* Estilos para Tablet */
@media (min-width: 768px) and (max-width: 1024px) {
  .datatable {
    border-radius: 16px;
    margin-bottom: 24px;
    table-layout: fixed;
    width: 100%;
  }

  .datatable thead th {
    padding: 16px 12px;
    font-size: 12px;
    letter-spacing: 0.05em;
  }

  .datatable tbody td {
    padding: 16px 6px;
    font-size: 12px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .datatable tfoot td {
    padding: 16px 12px;
    font-size: 12px;
  }

  /* Ajustes específicos para colunas */
  .datatable thead th:nth-child(1),
  .datatable tbody td:nth-child(1) {
    width: 15%;
    min-width: 100px;
  }

  .datatable thead th:nth-child(2),
  .datatable tbody td:nth-child(2) {
    width: 38%;
    min-width: 200px;
  }

  .datatable thead th:nth-child(3),
  .datatable tbody td:nth-child(3) {
    width: 15%;
    min-width: 80px;
  }

  .datatable thead th:nth-child(4),
  .datatable tbody td:nth-child(4) {
    width: 14%;
    min-width: 100px;
  }

  .datatable thead th:nth-child(5),
  .datatable tbody td:nth-child(5) {
    width: 15%;
    min-width: 100px;
  }

  .datatable thead th:nth-child(6),
  .datatable tbody td:nth-child(6) {
    width: 6%;
    min-width: 50px;
  }
}
</style>
